export const environment = {
  production: false,
  apiUrl: 'https://claims-sparci-qa.unilever.com',
  socketUrl:
    'https://bnlwe-es02-q-931435-unilevercom-webapp-01.azurewebsites.net',
  msalConfig: {
    auth: {
      clientId: '60922018-9804-4991-b274-eb5efecc8da6',
      authority:
        'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
      // redirectUri: 'http://localhost:4200',
      redirectUri: 'https://claims-sparci-qa.unilever.com/',
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/.default',
  },
  // apiUrl: 'https://sparci-dev.unilever.com',

  // clientId: '955fde3e-e37e-42a7-98b3-64882b3e2aca',
  // tenantId: 'f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
  // authority:
  //   'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
  // // redirectUri: 'http://localhost:4300/',
  // redirectUri: 'https://sparci-dev.unilever.com/.auth/login/aad/callback',
};

// export const environment = {
//   production: false,
//   apiUrl: 'https://bnlwe-es02-q-931435-unilevercom-webapp-02',
//   msalConfig: {
//     auth: {
//       clientId: '8bebb4c6-8d69-4ff0-8a39-9af9a014ee94',
//       authority:
//         'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
//       // redirectUri: 'http://localhost:4200',
//       redirectUri: 'https://sparciunlvrappuidev.azurewebsites.net',
//     },
//   },
//   apiConfig: {
//     scopes: ['user.read'],
//     uri: 'https://graph.microsoft.com/v1.0/me',
//   },
//   // apiUrl: 'https://sparci-dev.unilever.com',

//   // clientId: '955fde3e-e37e-42a7-98b3-64882b3e2aca',
//   // tenantId: 'f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
//   // authority:
//   //   'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
//   // // redirectUri: 'http://localhost:4300/',
//   // redirectUri: 'https://sparci-dev.unilever.com/.auth/login/aad/callback',
// };
